/** @format */

import { doc, getDoc, updateDoc, deleteDoc } from "firebase/firestore/lite";
import { db, setIdea } from "senf-shared";

import { clearErrors } from "./errorsActions";
import { DELETE_IDEA, EDIT_IDEA, LOADING_UI, SET_IDEA } from "../types";

// Open an idea
export const getIdea = (ideaId, project, ideaMap) => async (dispatch) => {
  const idea = await setIdea(ideaId, project, ideaMap);
  dispatch({ type: SET_IDEA, payload: idea });
};

// Delete your idea
export const deleteIdea = (project, ideaId, user) => async (dispatch) => {
  if (!project) throw new Error("No project provided in deleteIdea");
  if (!project.organizationId)
    throw new Error("No organizationId provided in deleteIdea");
  if (!project.projectId)
    throw new Error("No projectId provided in deleteIdea");
  if (!ideaId) throw new Error("No ideaId provided in deleteIdea");
  try {
    const docRef = doc(
      db,
      `organizations/${project.organizationId}/projects/${project.projectId}/ideas/${ideaId}`
    );
    const idea = await getDoc(docRef);
    if (!idea.exists()) throw new Error("Idea has not been found");

    if (
      idea.data().userId === user.userId ||
      user.isAdmin ||
      user.isModerator
    ) {
      await deleteDoc(docRef);

      dispatch({
        type: DELETE_IDEA,
        payload: ideaId,
      });
      dispatch({ type: SET_IDEA, payload: {} });
    } else {
      throw new Error(`cant delete this users${idea.data().userHandle} idea`);
    }
  } catch (error) {
    throw new Error(error, "error in deleteIdeaFunc");
  }
};

export const getUserEmail = (userId) => async (dispatch) => {
  try {
    const docRef = doc(db, "users", userId, "Private", userId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      // console.log(docSnap.data(), "userEmail");
    } else {
      throw new Error("User email not found");
    }
  } catch (error) {
    throw new Error(error, "error in getUserEmailFunc");
  }
};
